import dynamic from 'next/dynamic';
import { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { AudioStockItem } from '@videoblocks/search-gateway-client';

import AudioPlayerArtists from './AudioPlayerArtists';
import AudioPlayerTitle from './AudioPlayerTitle';
import AudioTopTags from './AudioTopTags';

const StaffPickTag = dynamic(() => import('@videoblocks/storywind').then((mod) => mod.StaffPickTag));
const NewTag = dynamic(() => import('@videoblocks/storywind').then((mod) => mod.NewTag));
const SfxTag = dynamic(() => import('@videoblocks/storywind').then((mod) => mod.SfxTag));

type Props = {
    stockItem: AudioStockItem;
    metadataClassNames?: string;
    artistClassNames?: string;
    openDetailsInNewWindow?: boolean;
    audioPlayerHeaderClassName?: string;
    position: number; // i.e. index in search results
};

const AudioMetadata = ({
    stockItem,
    metadataClassNames = '',
    artistClassNames = '',
    openDetailsInNewWindow,
    audioPlayerHeaderClassName,
    position,
}: Props): JSX.Element => (
    <div
        className={twMerge(
            'flex flex-col gap-y-1 items-start lg:w-max-[323px] w-full justify-center',
            metadataClassNames,
        )}
    >
        <div
            className={twMerge(
                'flex items-center gap-1.5 w-full',
                stockItem?.staffPickFlag ? 'flex-wrap' : 'flex-nowrap',
            )}
        >
            {stockItem.staffPickFlag && <StaffPickTag />}
            {stockItem.newFlag && <NewTag />}
            <AudioPlayerTitle
                stockItem={stockItem}
                className="text-black hover:text-blue-600"
                headerClassName={audioPlayerHeaderClassName}
                openDetailsInNewWindow={openDetailsInNewWindow}
                position={position}
            />
        </div>
        <AudioPlayerArtists
            stockItem={stockItem}
            className={twMerge('text-sm text-gray-700 hover:text-blue-500', artistClassNames)}
            wrapperClassName="text-gray-700"
        />
        <div className="flex w-full gap-x-2">
            {stockItem.contentType === 'sfx' && <SfxTag className="bg-green-700" />}
            <AudioTopTags stockItem={stockItem} openDetailsInNewWindow={openDetailsInNewWindow} />
        </div>
    </div>
);

export default AudioMetadata;
